/** @module Apparel/Theme/ThemeMasterForm */
define([
	"dojo/_base/declare",
	"dojo/_base/lang",
	"csi/def/Field",
	"csi/form/Widget",
	"csi/xml"
], function(declare,lang,Field,Widget,xml) {

	var SUBTYPE = "Subtype";

	return declare(Widget, {
		/**
		 * C8-11093: On ThemeMaster copy form, Subtype field should be readonly
		 */
		_buildField : function(ctx, field, tr, tdControl) {
			var name = field.getControlName();
			if (name == SUBTYPE && this.isCopy()) {
				field.m_right = xml.RIGHT_NONE;
			}

			return this.inherited(arguments);
		},

		/**
		 * @override
		 * C8-12862: Insert ThemeMaster.Subtype field if it hasn't been added to the FormDefinition
		 */
		_resolveView: function() {
			var fieldSubtype = this.defView.getField(SUBTYPE);
			if(!fieldSubtype) {
				this.insertField(lang.mixin(new Field(), {
					m_id: SUBTYPE,
					m_bRequired: true
				}), 0);
			}

			this.inherited(arguments);
		}

	});
});
